var firebaseConfig = {
    apiKey: "AIzaSyBzt489Q94v0mONzPifzcqwgRzR79fW3nE",
    authDomain: "critchfield-spray-foam.firebaseapp.com",
    databaseURL: "https://critchfield-spray-foam.firebaseio.com",
    projectId: "critchfield-spray-foam",
    storageBucket: "critchfield-spray-foam.appspot.com",
    messagingSenderId: "664838289093",
    appId: "1:664838289093:web:0e3f9fdcb4dcd98c"
  }

  export default firebaseConfig